<ng-container *ngIf="loaded">
  <div *ngIf="currentSectionIndex == null">
    <div class="container px-0">
      <h2 class="fs-35 mt-2 mb-0">
        {{ inspectionDefinition.inventoryItem.year }} {{ inspectionDefinition.inventoryItem.make }}
        {{ inspectionDefinition.inventoryItem.model }}
      </h2>
      <p class="small font-weight-light fs-18">SN: {{ inspectionDefinition.inventoryItem.serialNumber }}<br />{{ percentComplete | percent }} complete</p>
      <p class="fs-13 text-weight-light">If a question is not applicable, pass the question.</p>
      <ul class="list-group">
        <li
          class="list-group-item d-flex align-items-center"
          [class.text-dark-grey]="section.inProgress"
          [class.list-group-item-success]="section.complete"
          *ngFor="let section of inspectionForm.value.sections; index as i"
          (click)="goToSection(i)"
          [attr.rt]="'checklist-section-' + i"
        >
          <ng-container *ngIf="!section.complete && !section.inProgress">
            <span class="mr-1" *ngIf="!triedSubmitting">{{ i + 1 }}.</span>
            <i class="icon-alert text-warning fs-22 mr-2" *ngIf="triedSubmitting"></i>
          </ng-container>
          <i class="icon-check-circle-fill text-green fs-22 mr-2" *ngIf="section.complete"></i>
          <i class="icon-alert text-warning fs-22 mr-2" *ngIf="section.inProgress"></i>
          {{ section.title || "General Info" }}
          <i class="icon-arrow-right ml-auto"></i>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="currentSectionIndex != null">
    <div class="container bb-light progress-bar-container pt-2">
      <ngb-progressbar type="success" [value]="progressbarValue" height=".5rem"></ngb-progressbar>
      <div class="text-center fs-13 font-weight-light">Section {{ currentSectionIndex + 1 }} of {{ inspectionDefinition.sections.length }}</div>
    </div>
    <form class="form mt-2" [formGroup]="inspectionForm" (ngSubmit)="onSubmit()">
      <section formArrayName="sections">
        <!-- [@animSlider]="currentSectionIndex" -->
        <div class="container" *ngFor="let section of sections.controls; index as i;" [formGroupName]="i">
          <div class="" [hidden]="section.value.index != currentSectionIndex">
            <h2 class="fs-35" *ngIf="currentSectionIndex != null">{{ inspectionDefinition.sections[currentSectionIndex].title || "General Info" }}</h2>

            <div class="" formArrayName="inspectionSteps">
              <!--  start of steps -->
                <ng-container *ngFor="let step of stepsFormArray(section).controls; index as j; last as isLast" [formGroupName]="j">
                  <div class="card p-3 mb-4 bg-more-grey" style="margin-left:-15px;margin-right: -15px;" >
                    <div class="d-flex">
                      <div class="d-flex align-items-center">
                        <div class="d-flex flex-column line-height-required">
                          <app-questionmark-tooltip
                            *ngIf="step.value.helpText || step.value.title"
                            [questionmarkLabel]="step.value.title"
                            [displayLearnMore]="false"
                            questionMarkLabelClass="fs-18"
                            [text]="step.value.helpText"
                          >
                          </app-questionmark-tooltip>
                          <span
                            class="d-flex align-items-center text-red fs-13"
                            *ngIf="
                              (step?.controls?.answer && step?.controls?.answer?.errors?.required) ||
                              (step?.controls?.value && step?.controls?.value?.errors?.required)
                            "
                          >
                            <span class="font-weight-light">Required</span>
                          </span>
                        </div>
                      </div>
                      <div class="ml-auto">
                        <ng-container [ngSwitch]="step.value.stepType">
                          <!-- Start of verification step -->
                          <ng-container *ngSwitchCase="'VerificationStep'">
                            <div class="form-group">
                              <input type="text" class="form-control" [attr.rt]="'section' + i + '-step' + j + '-verification'" formControlName="value" />
                            </div>
                          </ng-container>
                          <!-- end of verification step -->
                          <!-- start of bool step -->
                          <ng-container *ngSwitchCase="'BoolStep'">
                            <div>
                              <div class="d-flex justify-content-between btn-group-toggle" data-toggle="buttons">
                                <label class="btn btn-pass mr-2 d-flex align-items-center justify-content-center" [class.active]="step.value.answer === true">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    [id]="step.value.title + step.value.positiveLabel"
                                    [attr.rt]="'section' + i + '-step' + j + '-pass'"
                                    [value]="true"
                                    formControlName="answer"
                                    (ngModelChange)="checkboxChange($event, step)"
                                  />
                                  <i class="icon-checkmark fs-24"></i>
                                </label>
    
                                <label class="btn btn-fail d-flex align-items-center justify-content-center" [class.active]="step.value.answer === false">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    [id]="step.value.title + step.value.negativeLabel"
                                    [attr.rt]="'section' + i + '-step' + j + '-fail'"
                                    [value]="false"
                                    formControlName="answer"
                                    (ngModelChange)="checkboxChange($event, step)"
                                  />
                                  <i class="icon-close fs-18"></i>
                                </label>
                              </div>
                            </div>
                          </ng-container>
                          <!-- end of bool step -->
                          <!-- start of bool step -->
                          <ng-container *ngSwitchCase="'DataCollection'"></ng-container>
                          <!-- end of bool step -->
                          <!-- start of multi acknowledgement step -->
                          <ng-container *ngSwitchCase="'MultiAcknowledgementStep'">
                            <div formArrayName="acknowledgements">
                              <ng-container *ngFor="let ack of getAcks(step).controls; index as s" [formGroupName]="s">
                                <div class="checkbox mb-2">
                                  <label class="checkbox-label cursor-pointer large">
                                    <input
                                      type="checkbox"
                                      formControlName="answer"
                                      [id]="step.value.title + s"
                                      [attr.rt]="'section' + i + '-step' + j + '-acknowledgement' + s"
                                      (change)="acknowledgementChange(step)"
                                    />
                                    <span
                                      class="cr"
                                      [ngStyle]="{
                                        'background-color': ack.controls.answer.value === true ? '#009688' : 'white',
                                        'border-color': ack.controls.answer.value === true ? '#009688' : '#B6BCC2'
                                      }"
                                    >
                                      <i class="cr-icon icon-checkmark"></i>
                                    </span>
                                    <span class="label-text">
                                      {{ ack.value.description }}
                                      <div class="text-red d-flex align-items-center ml-2 fs-13" *ngIf="ack.controls?.answer?.errors?.required">
                                        <span class="font-weight-light">Required</span>
                                      </div>
                                    </span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                          <!-- end of multi acknowledgement step -->
                        </ng-container>
                      </div>
                    </div>
    
                    <!-- START OF INPUTS -->
                    <div formArrayName="inputs">
                      <ng-container *ngFor="let input of getInputs(step).controls; index as g" [formGroupName]="g">
                        <!-- We only want to show the add notes button if it is notes -->
                        <div class="form-group mb-4" *ngIf="showInput(step.value, input)">
                          <label class="d-inline-flex align-items-baseline font-weight-light">{{ input.value.instruction }}</label>
                          <div>
                            <!-- Input type switch -->
                            <ng-container [ngSwitch]="input.value.inputType">
                              <!-- Video -->
                              <ng-container *ngSwitchCase="'Video'">
                                <div class="mb-3">
                                  <ng-container *ngIf="input.value.videoStorage"
                                    >Video saved - <a class="text-green cursor-pointer" (click)="deleteVideo(input)">Delete</a>
                                  </ng-container>
                                  <ng-container *ngIf="!input.value.videoStorage">
                                    <button
                                      class="btn btn-outline-gray btn-block btn-mobile d-flex align-items-center justify-content-center mb-2 bg-white"
                                      [attr.rt]="'section' + i + '-step' + j + '-input' + g"
                                      type="button"
                                      (click)="recordVideo(input)"
                                    >
                                      <i class="icon-instagram text-green fs-28 mr-1"></i> Record video
                                    </button>
                                    <label class="fs-14 small">Bad cell service? Record on your phone and upload here once on wifi.</label>
                                    <button
                                      class="btn btn-outline-gray btn-block btn-mobile d-flex align-items-center justify-content-center mb-2 bg-white"
                                      [attr.rt]="'section' + i + '-step' + j + '-input-video-upload' + g"
                                      type="button"
                                      (click)="fileInputForVideo.click()"
                                    >
                                      <i class="icon-instagram text-green fs-28 mr-1"></i> Upload video
                                    </button>
                                    <input
                                      class="d-none"
                                      [attr.rt]="'section' + i + '-step' + j + '-input' + g + '-hidden-video'"
                                      type="file"
                                      #fileInputForVideo
                                      accept="video/*"
                                      (change)="uploadFakeVideo($event, input)"
                                    />
                                  </ng-container>
                                </div>
                              </ng-container>
                              <!-- Photo -->
                              <ng-container *ngSwitchCase="'Photo'">
                                <common-image-preview-upload
                                  [rt]="'section' + i + '-step' + j + '-input' + g"
                                  [expectedOrientation]="input.controls.expectedImageOrientation.value"
                                  [expectedOrientationMessage]="input.controls.expectedImageOrientationMessage.value"
                                  [imageBlob]="input.controls.storedImage.value"
                                  (imageBlobChange)="photoSelected(input, $event)"
                                ></common-image-preview-upload>
                              </ng-container>
                              <!-- Bar code scanner input -->
                              <ng-container *ngSwitchCase="'Barcode'">
                                <common-barcode-scanner
                                  [rt]="'section' + i + '-step' + j + '-input' + g"
                                  [barcodeValue]="input.controls.value.value"
                                  (barcodeChange)="barcodeValueSelected(input.controls.value, $event)"
                                  (onBlur)="verifyInputBlur(input.value, $event)"
                                ></common-barcode-scanner>
                              </ng-container>
                              <!-- Text input -->
                              <ng-container *ngSwitchCase="'Text'">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [attr.rt]="'section' + i + '-step' + j + '-input' + g"
                                    [class.text-grey]="recordingStarted"
                                    formControlName="value"
                                    (blur)="verifyInputBlur(input.value, $event)"
                                  />
                                </div>
                              </ng-container>
                              <!-- Dropdown -->
                              <ng-container *ngSwitchCase="'Dropdown'">
                                <common-dropdown
                                  [rt]="'section' + i + '-step' + j + '-input' + g"
                                  [dropDownItems]="input.value.dropdownItems"
                                  [enableSearch]="true"
                                  [selectedValue]="input.value.value"
                                  (itemSelected)="dropdownSelected(input, $event)"
                                ></common-dropdown>
                              </ng-container>
                            </ng-container>
                          </div>
                          <div
                            class="d-flex align-items-center text-red fs-13"
                            *ngIf="
                              (input?.controls?.storedImage && input?.controls?.storedImage?.errors?.required) ||
                              (input?.controls?.videoStorage && input?.controls?.videoStorage?.errors?.required) ||
                              (input?.controls?.value && input?.controls?.value?.errors?.required)
                            "
                          >
                            <span class="font-weight-light">Required</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <!-- end of inputs -->
    
                  </div>
              <!-- <div *ngIf="!isLast" class="bb-light mt-2 mb-4"></div> -->

                </ng-container>
            

            </div>
            <div class="d-flex justify-content-between mt-4" *ngIf="currentSectionIndex + 1 != inspectionDefinition.sections.length">
              <button
                type="button"
                class="btn btn-outline-secondary d-flex align-items-center justify-content-center btn-width-equal btn-mobile"
                (click)="previousSection(section)"
              >
                <i class="icon-arrow-left mr-2"></i> Back
              </button>
              <button type="button" class="btn d-flex align-items-center justify-content-center btn-width-equal btn-mobile" (click)="goToChecklist()">
                Checklist
              </button>
              <button
                type="button"
                class="btn btn-success d-flex align-items-center justify-content-center btn-width-equal btn-mobile"
                (click)="nextSection(section)"
              >
                Next <i class="icon-arrow-left ml-2" style="transform: rotate(180deg)"></i>
              </button>
            </div>
            <ng-container *ngIf="currentSectionIndex + 1 == inspectionDefinition.sections.length">
              <button class="btn btn-success btn-block btn-mobile mb-3" type="submit" rt="save-inspection" [disabled]="disableButton">Submit Inspection</button>
              <span class="text-green d-flex align-items-center justify-content-center" *ngIf="currentSectionIndex != 0" (click)="previousSection(section)"
                ><i class="icon-arrow-left mr-1 fs-20"></i> Previous section</span
              >
            </ng-container>
          </div>
        </div>
        <!-- end of for loop for sections -->
      </section>
      <div class="card mb-4" *ngIf="submitError">
        <div class="card-body">
          <p>Error</p>
          {{ submitError }}
        </div>
      </div>
    </form>
  </div>
</ng-container>

<div class="card" id="error" *ngIf="errorMessage">
  <div class="card-header">Error</div>
  <div class="card-body">
    <p class="w-100" [innerHtml]="errorMessage"></p>
    <p>Please contact support at <a href="tel:866-455-8531">866-455-8531</a></p>
    <a class="text-green" (click)="shareError()">Share error</a>
  </div>
</div>
